"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var useInterval = function useInterval(callback, delay) {
  var savedCallback = (0, _react.useRef)();

  // Remember last callback
  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]);

  // set up interval
  (0, _react.useEffect)(function () {
    if (delay !== null) {
      var id = setInterval(function () {
        savedCallback.current();
      }, delay);
      return function () {
        return clearInterval(id);
      };
    }
    return null;
  }, [delay]);
};
var _default = exports["default"] = useInterval;